import * as React from "react";
import {maxValue, minValue, NumberField, NumberInput, useRecordContext} from 'react-admin';
import {Edit, Link, required, SaveButton, SelectField, SelectInput, SimpleForm, TextInput,} from "react-admin";
import { useWatch } from 'react-hook-form';

export const AiSettingsEdit = () => {
    const Save = () => {
        return (
            <div className="customerActionToolbar edit-user-btns">
                <Link to={`/ai/settings/custom/show`} className="button bar-purple-button">Cancel</Link>
                <SaveButton alwaysEnable label="Save" className="button bar-gradient-button" icon={<></>}/>
            </div>
        );
    }

    const ViewFields = props => {
        const model = useWatch({ name: 'model' });

        if (model === "gpt-4.1") {
            return (
            <div>
                <TextInput
                    helperText={'Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic'}
                    label="Temperature (0.0 - 2.0):"
                    name="temperature" source="temperature" id="temperature" validate={required()} multiline fullWidth
                />
                <NumberInput  helperText={
                    <div>- An upper bound for the number of tokens that can be generated for a completion, including visible output tokens and reasoning tokens.</div>
                }
                   label="Tokens:"  name="token" source="token" id="token"
                   multiline fullWidth
                   defaultValue={2048}
                   validate={[minValue(16), required(), maxValue(32768)]}
                />
            </div>)
        }

        if (model === "gpt-5.2") {
            return (
        <div>
            <SelectInput
            helperText={
                <div>
                    <div>- Reducing reasoning effort can result in faster responses and fewer tokens used on reasoning in a response</div>
                    <div>- All models before gpt-5.1 default to medium reasoning effort</div>
                </div>
            }
            label="Effort:" name="effort" source="effort" fullWidth id="effort" validate={required()} multiline defaultValue={'medium'}
            choices={[
                {id: "none", name: "None"},
                {id: "low", name: "Low"},
                {id: "medium", name: "Medium"},
                {id: "high", name: "High"}
            ]}/>
            <SelectInput
            helperText={
                <div>
                    - Constrains the verbosity of the model's response. Lower values will result in more concise responses, while higher values will result in more verbose responses.
                </div>
            }
            label="Verbosity:" name="verbosity" source="verbosity" fullWidth id="verbosity" validate={required()} multiline defaultValue={'medium'}
            choices={[
                {id: "low", name: "Low"},
                {id: "medium", name: "Medium"},
                {id: "high", name: "High"}
            ]}/>
            <TextInput  helperText={
                <div>- An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered.</div>
            }
            label="Top P (0.0 - 1.0):" defaultValue={1}
            name="top_p" source="top_p" id="top_p"
            validate={required()} multiline fullWidth/>
        </div>
            )
        }
        return '-';
    };

    return <div className="edit-customer">
        <h2 className="dailyTitle">AI Model Settings</h2>
        <Edit  mutationMode="optimistic" redirect={'show'}>
            <SimpleForm   toolbar={<Save/>}>
                <SelectInput label="OpenAI Model:" name="model" source="model" fullWidth id="model" validate={required()} multiline choices={[
                    {id: "gpt-4.1", name: "GPT-4.1"},
                    {id: "gpt-5.2", name: "GPT-5.2"}
                ]}/>
                <ViewFields />
                <SelectInput
                    helperText={
                        <div>
                            - Whether or not to store the output of this chat completion request for use in model distillation or evals products.
                        </div>
                    }
                    label="Store:" name="store" source="store" fullWidth id="store"  multiline defaultValue={'false'}
                    choices={[
                        {id: 10, name: "Yes"},
                        {id: 0, name: "No"}
                    ]}/>
                <TextInput rows={10}  label="System Prompt:" name="systemPrompt" source="systemPrompt" id="systemPrompt"  validate={required()} multiline fullWidth/>
                <TextInput rows={10} label="User Prompt Template:" name="promptTemplate" source="promptTemplate" id="promptTemplate"  validate={required()} multiline fullWidth/>
            </SimpleForm>
        </Edit>
    </div>
}